/* @flow */

export default class RenewCompanyMembershipRequest {
  companyId: number;

  constructor(companyId: number) {
    this.companyId = companyId;
  }
}
